export enum StorkUserSettings {
    BUSINESS_AREA = 'stork:business_area',
    // For carrier users with limited vehicles to view
    VEHICLES_TO_VIEW = 'stork:vehicles_to_view',
    DRIVERS_TO_VIEW = 'stork:drivers_to_view',
    MAP_MONITORING_MODE = 'stork:use_map_monitoring_mode',
    IS_DEMO = 'stork:is_demo',
    /**
     * Los contenedores del tablero de incidencias, serializados.
     *
     * Van en el bag de settings del usuario y no en una colección propia porque
     * son preferencias de pantalla: no las lee nadie más que quien las armó, no
     * hay nada que consultar por ellas, y acá ya viven las otras preferencias de
     * Stork. Ver user-profile.service.ts.
     */
    INCIDENT_BOARD_PROFILES = 'stork:incident_board_profiles',
}
